import { User } from '../../core/models/auth.interface';

export interface AuthState {
  user: User | null;
  isAuthenticated: boolean;
  accessToken: string | null;
  refreshToken: string | null;
}

export const initialAuthState: AuthState = {
  user: null,
  isAuthenticated: false,
  accessToken: null,
  refreshToken: null
};
